import {isAdmin, isSelectiveAiDomains} from 'common/HelperFunctions'
import Spinner from 'common/components/Spinner'
import {useState} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {getAccessToken} from 'setup/redux/Actions/Timetable/timetable'

import {getTheme} from '_metronic/partials'

const PLAN_SELECTION_PATH = '/PlanSelection'

const getAiCreditsBaseUrl = () => {
  if (window.location.hostname.includes('da1timetable.info')) {
    return 'https://dev-subscription.ilmversity.ai/ai-credits'
  }
  const envUrl = (import.meta.env.VITE_APP_AI_CREDITS_URL ?? '').trim()
  return envUrl || 'https://subscription.ilmversity.ai/ai-credits'
}

const SidebarBuyAiCredits = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  // Only an admin can buy credits or see the balance; teachers and staff never get the button.
  if (!isSelectiveAiDomains() || !isAdmin()) return null

  const handleBuyAiCredits = () => {
    setLoading(true)
    dispatch(
      getAccessToken(
        (response: any) => {
          const {accessToken, urdd_id} = response.result || response
          if (accessToken && urdd_id) {
            const baseUrl = getAiCreditsBaseUrl().replace(/\/$/, '')
            const sourceDomain = window.location.hostname
            const theme = getTheme()
            const returnTo = window.location.href
            const url = `${baseUrl}${PLAN_SELECTION_PATH}?accessToken=${encodeURIComponent(
              accessToken
            )}&urdd_id=${encodeURIComponent(urdd_id)}&sourceDomain=${encodeURIComponent(
              sourceDomain
            )}&theme=${encodeURIComponent(theme)}&returnTo=${encodeURIComponent(
              returnTo
            )}&intent=planSelection`
            window.location.href = url
          } else {
            setLoading(false)
          }
        },
        () => setLoading(false)
      )
    )
  }

  return (
    <div className='app-sidebar-buy-ai-credits flex-shrink-0 pt-2 pb-6 px-3'>
      <button
        type='button'
        onClick={handleBuyAiCredits}
        disabled={loading}
        className='btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 text-nowrap py-3 px-4 rounded-pill shadow-sm'
        style={{minHeight: '44px'}}
      >
        {loading ? (
          <>
            <Spinner size='sm' type='border' className='flex-shrink-0' />
            <span className='fw-bold app-sidebar-minimize-d-none'>
              {intl.formatMessage({id: 'COMMON.LOADING'}, {defaultMessage: 'Loading...'})}
            </span>
          </>
        ) : (
          <>
            <i className='fa-solid fa-coins fs-3 app-sidebar-minimize-d-none' aria-hidden />
            <i className='fa-solid fa-coins fs-3 app-sidebar-minimize-d-flex d-none' aria-hidden />
            <span className='fw-bold fs-6 app-sidebar-minimize-d-none'>
              {intl.formatMessage({id: 'MENU.BUY_AI_CREDITS'})}
            </span>
            <i className='fa-solid fa-arrow-right fs-7 app-sidebar-minimize-d-none' aria-hidden />
          </>
        )}
      </button>
    </div>
  )
}

export {SidebarBuyAiCredits}
